<template>
  <div class="list">
    <home-banner ref="homeBanner" :height="400"></home-banner>
    <div class="clear"></div>
    <div class="listMain wrap">
      <div class="listMainBox">
        <div class="listMainLeft fl">
          <div class="listSlidHd">
            <div class="pic">
              <img src="../assets/img/zi_left_b.png" alt="" />
            </div>
            <div class="title">
              {{ slideHdParentName }}
            </div>
            <div class="txt">
              匠心营造 精益求精
            </div>
          </div>
          <div class="listSlid">
            <div class="listSlidList">
              <div class="listSlidList_line" v-for="(item, index) in slideList" :key="index">
                <div class="listSlidListInner" :class="{ on: active == item.entTChannelUuid }">
                  <!-- <a 
                  v-if="item.url && item.url !== ''" 
                  target="_blank" 
                  :href="item.url">
                  {{item.name}}
                  </a> -->
                  <a
                    v-if="!item.url || item.url == ''"
                    :href="
                      item.catalog === 1
                        ? `/listPage/${item.entTChannelUuid}`
                        : item.catalog === 2
                        ? `/list/${item.entTChannelUuid}`
                        : `/listPic/${item.entTChannelUuid}`
                    "
                  >
                    {{ item.name }}
                  </a>
                </div>
                <div class="thirdNav" v-if="item.child.length != 0">
                  <div class="thirdNav_line" v-for="(item1, index1) in item.child" :key="index1">
                    <a v-if="item1.url && item1.url !== ''" target="_blank" :href="item1.url">
                      {{ item1.name }}
                    </a>
                    <a
                      v-if="!item1.url || item1.url == ''"
                      :href="
                        item1.catalog === 1
                          ? `/listPage/${item.entTChannelUuid}`
                          : item1.catalog === 2
                          ? `/list/${item1.entTChannelUuid}`
                          : `/listPic/${item1.entTChannelUuid}`
                      "
                    >
                      {{ item1.name }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="listMainRight fr" style="width:930px;float:right;overflow:hidden;">
          <div class="listWrap">
            <div class="listHd clearfloat">
              <div class="listpot">{{ slideHdTitle }}</div>
              <div class="fl listHdGrop">
                <span class="listHdIco"><i class="el-icon-s-home"></i></span> 您当前所在位置：<a href="/">首页</a> >
                <span v-if="viewSlideHdParent"
                  ><a :href="slideHdParentUrl">{{ slideHdParentName }}</a>
                </span>
                <span v-if="slideHdName2 != ''" class="txt">> {{ slideHdName2 }} </span
                ><span v-if="isthird" class="txt">> {{ slideHdName1 }}</span>
              </div>
            </div>
            <div class="listContainer">
              <div class="contactBody" v-html="pageCont"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getChildChannel, getChannelInfo, increaseViews, getArtInfoByChannel } from '@/api/common'
import homeBanner from '@/components/swiper.vue'
export default {
  name: 'list',
  components: {
    homeBanner
  },
  data() {
    return {
      isthird: false,
      isClickid: '',
      isClickid2: '',
      slideHdName1: '',
      slideHdName2: '',
      slideHdTitle: '',
      viewSlideHdParent: true,
      slideHdParentName: '',
      slideHdParentUrl: '',
      slideHdName: '',
      hdTitle: '',
      hdName: '',
      pageCont: '',
      active: 0,
      slideHd: {
        title: '新闻动态'
      },
      slideList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      listData: []
    }
  },
  mounted() {
    var _this = this
    _this.active = _this.$route.params.id
    _this.listId = _this.$route.params.id
    // _this.getChildChannel()
    _this.getChannelInfo()
    _this.getArtInfoByChannel()
  },
  methods: {
    // 查询二级栏目
    getChildChannel(id) {
      var _this = this

      let data = {
        applicationUuid: _this.webId,
        parentUuid: id
      }
      getChildChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.slideList = data
          if (_this.slideList.length) {
            _this.viewSlideHdParent = true
            let url = ''
            if (_this.slideList[0].catalog === 1) {
              url = `/listPage/${_this.slideList[0].entTChannelUuid}`
            } else if (_this.slideList[0].catalog === 2) {
              url = `/list/${_this.slideList[0].entTChannelUuid}`
            } else {
              url = `/listPic/${_this.slideList[0].entTChannelUuid}`
            }
            _this.slideHdParentUrl = url
          } else {
            _this.viewSlideHdParent = false
          }
        }
      })
    },
    getChannelInfo() {
      var _this = this
      let params1 = {
        channelUuid: _this.$route.params.id
      }
      getChannelInfo(params1).then(res => {
        const { code, data } = res
        console.log(code, data)
        if (code === 1 && data) {
          if (data.parentUuid == '0') {
            _this.slideHdTitle = data.name
            _this.slideHdParentName = data.name
            return
          }
          _this.slideHdName1 = data.name
          let params2 = {
            channelUuid: data.parentUuid
          }
          getChannelInfo(params2).then(res => {
            const { code, data } = res
            if (code === 1 && data) {
              if (data.parentUuid == '0') {
                _this.getChildChannel(data.entTChannelUuid)
                _this.slideHdParentName = data.name
                _this.slideHdName2 = _this.slideHdName1
                _this.slideHdTitle = _this.slideHdName2
                _this.isthird = false
              } else {
                _this.isthird = true
                _this.getChildChannel(data.parentUuid)
                _this.slideHdName2 = data.name
                _this.isClickid = data.channelId
                let params3 = {
                  channelUuid: data.parentUuid
                }
                getChannelInfo(params3).then(res => {
                  const { code, data } = res
                  if (code === 1 && data) {
                    _this.slideHdParentName = data.name
                    _this.slideHdTitle = _this.slideHdName1
                    _this.isClickid2 = _this.slideHdName1
                  }
                })
              }
            }
          })
        }
      })
    },
    //
    getArtInfoByChannel() {
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: _this.$route.params.id
      }
      getArtInfoByChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.pageCont = data.content
          this.increaseViews(data.entTArticleUuid)
        }
      })
    },
    increaseViews(id) {
      let data = {
        entTArticleUuid: id
      }
      increaseViews(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          // _this.dataView = data
          // console.log(111,_this.dataView)
        }
      })
    }
  }
}
</script>
<style>
.contactBody {
  width: 100%;
  height: auto;
  min-height: 500px;
  line-height: 30px;
}
.listSlidListInner.on a {
  background-color: #0062b3;
  color: #ffffff;
}
.listSlidList {
  margin-top: 100px;
}
.listSlidHd {
  width: 235px;
  height: 230px;
  background-color: #0062b3;
  color: #ffffff;
  position: absolute;
  margin-top: -111px;
  z-index: 9999999;
}
.listSlidHd .pic {
  width: 64px;
  height: 73px;
  margin: 26px auto 0px auto;
}
.listSlidHd .title {
  width: 100%;
  height: 54px;
  line-height: 54px;
  text-align: center;
  font-size: 24px;
  margin-top: 4px;
}
.listSlidHd .txt {
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 16px;
  text-align: center;
  color: #97bde1;
  margin-top: 10px;
}
.listSlidList_line {
  width: 100%;
  height: 50px;
  display: block;
  background-color: #e8e8e8;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  color: #000;
  margin-bottom: 5px;
  font-weight: bolder;
}
.listSlidListInner:hover {
  background-color: #0062b3;
  color: #fff;
}
.listMain {
  height: auto;
  overflow: hidden;
}

.wrap {
  min-height: 897px;
  height: auto;
}
.listSlid {
  width: 235px;
  height: auto;
  margin-top: 126px;
}
.listpot {
  width: 200px;
  height: 35px;
  line-height: 35px;
  float: left;
  font-size: 14px;
}
.listHdGrop {
  width: 700px;
  text-align: right;
  height: 25px;
  line-height: 25px;
  margin-top: 10px;
  float: right;
  font-size: 12px;
  color: #9a9a9a;
}
.listHdGrop a {
  font-size: 12px;
  color: #9a9a9a;
}
.listHd {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #d6d6d6;
}
.listContainer {
  padding: 0 10px;
}
.listContainer .contactBody p {
  padding: 0;
  line-height: 3em;
  text-indent: 0;
  font-family: 宋体;
  font-size: 18px;
  line-height: 28px;
  margin: 5px 0;
}
.listSlidListInner a:hover {
  color: #fff;
}
.listSlidListInner a {
  display: block;
  width: 100%;
}

.thirdNav_line a:hover {
  color: #fff;
}
</style>
